/**
 配置管理--设备快速查询--订单信息；在线运维--订单列表
 具体展示内容
 */
import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { Modal, message } from "antd";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import FormCore from "@/components/display/form/formCore";
import fetchHandlerFunc from "@/fetch/fetchHandler";
import {
  getStubOrderInfoList,
  endCodeInfo,
  appKeyInfo,
  getCityList,
  stubGroupNameSearch,
  prefixFile,
  orderForceStop,
  exportChargingData,
} from "@/fetch/fetchApi";

import ScGridTable from "@/components/display/table/gridTableCore";
// 其他组件
import OrderDetailInfo from "./orderDetailInfo";
import RefreshGrid from "../../../utils/refreshGrid";
import StubGroupChoose from "./stubGroupChoose";
import StubTempMonitoring from "./stubTempMonitoring";
import { useAuth } from "@/utils/utils";

const opType = {
  0: [
    {
      text: "全部",
      value: "",
    },
    {
      text: "平台托管联营站",
      value: "0",
    },
    {
      text: "品牌联营站",
      value: "1",
    },
    {
      text: "互联互通联营站",
      value: "2",
    },
    {
      text: "专用开放站",
      value: "3",
    },
    {
      text: "专用内部站",
      value: "4",
    },
    {
      text: "品牌站",
      value: "5",
    },
    // ,
    // {
    //   text: '互联互通站',
    //   value: "7",
    // }
  ],
  1: [
    {
      text: "全部",
      value: "",
    },
    {
      text: "自建站", // '自建站',
      value: "6",
    },
    {
      text: "共建站", // '自建站',
      value: "8",
    },
  ],
};
@connect((state) => state)
class StubOrderInfo extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubOrderInfo;
    this.yunwei = this.props.intl.messages.commonBase;
    let stubId = "";
    let stubGroupId = "";
    let stubName = "";
    let time = "";

    if (window.LayoutTab.tabParam.stubGroupId) {
      stubGroupId = window.LayoutTab.tabParam.stubGroupId;
      stubName = window.LayoutTab.tabParam.StubName;
    }

    if (this.props.params) {
      if (this.props.params.key) {
        stubId = this.props.params.key;
      } else if (this.props.params.stubId) {
        stubId = this.props.params.stubId;
      }
      if (this.props.params.searchTime) {
        time = moment(this.props.params.searchTime).format("YYYY-MM-DD");
      }
    }
    // this.props.params
    // ? this.props.params.key
    //   ? this.props.params.key
    //   : this.props.params.stubId
    //     ? this.props.params.stubId
    //     : ""
    // : ""

    // this.props.params
    // ? this.props.params.searchTime
    //   ? moment(this.props.params.searchTime).format("YYYY-MM-DD")
    //   : ""
    // : ""
    this.state = {
      stubId: stubId,
      time: time,
      stationTypeOptions: [
        {
          text: "全部",
          value: "",
        },
      ],
      searchStubGroupId: stubGroupId,
      typeOption: [
        {
          text: this.props.intl.messages.commonBase.wz10, // '全部',
          value: "",
        },
      ],
      stubGroupId: stubGroupId,
      choosedStubGroupName: stubName,
      seeChooseState: false,
      seeTempMonitoringState: false,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
    this.tableKeyRamdom = `orderInfoTableStub${Math.floor(Math.random() * 100)}`;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    /**
     * 初始化form查询表单
     */
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.initTable();
    this.getCityList();
  }

  componentDidMount() {
    const time =
      this.state.time === ""
        ? `${moment(new Date()).subtract(7, "d").format("YYYY-MM-DD")},${moment(new Date())
            .subtract(0, "d")
            .format("YYYY-MM-DD")}`
        : `${moment(this.state.time).subtract(7, "d").format("YYYY-MM-DD")},${moment(
            this.state.time,
          )
            .subtract(0, "d")
            .format("YYYY-MM-DD")}`;

    this.fetchApi({
      stubId: this.state.stubId,
      stubGroupId: this.state.stubGroupId,
      date: time,
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandlerFunc(getCityList, { userId: sessionStorage.getItem("userId") }).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      // this.quanguoCityArry = [
      //   {
      //     title: "全国",
      //     value: "000000",
      //     key: "000000",
      //     children: JSON.parse(JSON.stringify(cityAryy)),
      //   },
      // ];

      this.quanguoCityArry = JSON.parse(JSON.stringify(cityAryy));
      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityArry;
      } else {
        quanguoCityArryCVal = this.quanguoCityArry;
      }
      // 设置数据
      // console.info('囫')
      // console.info(this.state.quanguoCityArry)
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
    }
  };

  /**
   * 初始化表格方法
   */
  initFormConfig() {
    // 设置查询时间
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.wz1, // '请输入业务订单号',
          param: {
            name: "bussinessId",
            type: "string",
          },
          labelName: this.internationalization.wz2, // '业务订单号',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.wz3, // '请输入平台订单号',
          param: {
            name: "platformId",
            type: "string",
          },
          labelName: this.internationalization.wz4, // '平台订单号',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.wz5, // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          defaultValue: this.state.stubId,
          labelName: this.internationalization.wz6, // '设备编号',
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入用户手机号", // '请输入用户编号',
          param: {
            name: "phone",
            type: "string",
          },
          labelName: "用户手机号", // '用户手机号：',
          required: false,
        },
        {
          type: "autoWatchFetch",
          placeholder: "请输入电站名称", // '请输入电站名称',
          labelName: "电站名称", // '电站名称',
          param: {
            name: "stubGroupId",
            type: "string",
          },
          optionInfo: {
            optionKey: "id",
            optionText: "name",
          },
          defaultValue: this.state.choosedStubGroupName,
          searchParam: {},
          searchListName: "stubGroupList",
          searchKey: "stubGroupListByName",
          required: false,
          onSelect: (value, option) => {
            this.setState({
              searchStubGroupId: option.key,
            });
          },
          onChange: () => {
            if (this.state.searchStubGroupId) {
              this.setState({
                searchStubGroupId: "",
              });
            }
          },
          sourceApi: stubGroupNameSearch,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },
        // {
        //   type: "areaPicker",
        //   isPickArea: !0,
        //   placeholder: "请选择地区", // '请选择地区',
        //   pickOnSelect: true,
        //   param: {
        //     name: "cityId", // 与form表单绑定的参数名
        //     type: "array",
        //   },
        //   required: !1,
        //   labelName: "地区", // '地区',
        //   className: "allshow",
        //   sourceApi: getCityList,
        //   mapKey: {
        //     label: "label",
        //     value: "value",
        //     children: "children",
        //   },
        // },
        {
          type: "autoWatchFetch",
          placeholder: "请输入后选择充电应用", // '请输入充电应用',
          param: {
            name: "appkey",
            type: "string",
          },
          optionInfo: {
            optionKey: "orgCode",
            optionText: "companyName",
          },
          searchParam: {},
          searchKey: "appKeyName",
          searchListName: "appKeyList",
          labelName: this.internationalization.wz10, // '充电应用',
          required: false,
          onSelect: (value, option) => {
            this.setState({
              searchAppKey: option.key,
            });
          },
          onChange: () => {
            if (this.state.searchAppKey) {
              this.setState({
                searchAppKey: "",
              });
            }
          },
          sourceApi: appKeyInfo,
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: [
            this.internationalization.placeholder1,
            this.internationalization.placeholder1,
          ],
          param: {
            name: "date",
            type: "array",
          },
          width: "200px",
          allowClear: false,
          defaultValue:
            this.state.time === ""
              ? [moment(new Date()).subtract(7, "d"), moment(new Date())]
              : [moment(this.state.time).subtract(7, "d"), moment(this.state.time)],
          range: window.sessionStorage.getItem("companyId") !== "1" ? [31, 0] : null, // 不等于1的是企业账号 31为从今天往前推31天，0为今天
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 31, // 最大可选天数
          }, // 自定义校验规则
          labelName: this.internationalization.wz11, // '订单结束时间:',
          required: !1,
        },
        {
          type: "endCodeSelect",
          placeholder: this.internationalization.wz12, // '请选择停止原因',
          labelName: this.internationalization.wz13, // '停止原因',
          param: {
            name: "endCode",
            type: "string",
          },
          onSelect: (value, option) => {
            this.setState({
              searchEndCode: option.key,
            });
          },
          onChange: () => {
            this.setState({
              searchEndCode: "",
            });
          },
          options: [],
          required: false,
          sourceApi: endCodeInfo,
          showParam: "endCodeName",
          choseParam: "endCodeName",
          keyParam: "endCode",
        },
        {
          type: "select",
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "未知",
              value: "0",
            },
            {
              text: "APP或微信启动",
              value: "1",
            },
            {
              text: "计费卡启动",
              value: "2",
            },
            {
              text: "不计费卡启动",
              value: "3",
            },
            {
              text: "按钮或屏幕启动",
              value: "4",
            },
            {
              text: "擦枪启动",
              value: "5",
            },
            {
              text: "命令启动",
              value: "6",
            },
            {
              text: "桩定时启动",
              value: "7",
            },
            {
              text: "银联卡启动",
              value: "8",
            },
            {
              text: "互联互通启动",
              value: "9",
            },
            {
              text: "辅枪启动",
              value: "10",
            },
            {
              text: "在线VIN",
              value: "11",
            },
            {
              text: "离线VIN",
              value: "12",
            },
            {
              text: "受电弓",
              value: "13",
            },
            {
              text: "在线蓝牙MAC启动",
              value: "14",
            },
            {
              text: "OCPP小票机",
              value: "15",
            },
            {
              text: "预约即插即充",
              value: "16",
            },
            {
              text: "vin即插即充",
              value: "17",
            },
            {
              text: "在线蓝牙启动",
              value: "18",
            },
            {
              text: "蓝牙即插即充",
              value: "19",
            },
            {
              text: "支付宝车生活启动",
              value: "20",
            },
          ],
          placeholder: "请选择", // '请选择场站类型',
          param: {
            name: "startType",
            type: "string",
          },
          labelName: "启动方式", // '场站类型',
          required: false,
        },
        {
          type: "select",
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非自营",
              value: "0",
            },
            {
              text: "自营",
              value: "1",
            },
          ],
          placeholder: "请选择", // '请选择场站类型',
          param: {
            name: "type",
            type: "string",
          },
          labelName: "运营类型", // '场站类型',
          required: false,
          onChange: (e, form) => {
            form.setFieldsValue({
              powerStationType: "",
              type: e,
            });
            let stationTypeOptions = [];
            if (e && e != null && e != "") {
              stationTypeOptions = opType[e];
            }
            this.setState(
              {
                stationTypeOptions: stationTypeOptions,
              },
              () => {
                this.setState({
                  formConfig: this.initFormConfig(),
                });
              },
            );
          },
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择电站类型',
          labelName: "电站类型", // '电站类型',
          param: {
            name: "powerStationType",
            type: "string",
          },
          options: this.state.stationTypeOptions,
          required: false,
          defaultValue: this.powerStationType ? this.powerStationType : "",
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("050101")
              ? {
                  btnType: "submit",
                  text: this.internationalization.btn1, // '查询',
                  // icon: 'search'
                }
              : "",
            useAuth("050102")
              ? {
                  btnType: "button",
                  text: "导出",
                  handler: (e, param) => {
                    const newParam = param;
                    const date = newParam.date.split(",");
                    newParam.startTime = date[0];
                    newParam.endTime = date[1];
                    delete newParam.date;
                    // 设置充电app
                    if (newParam.appkey) {
                      if (this.state.searchAppKey) {
                        newParam.appkey = this.state.searchAppKey;
                      }
                    } else {
                      newParam.appkey = "";
                    }
                    // newParam.appkey = newParam.appkey
                    //   ? this.state.searchAppKey
                    //     ? this.state.searchAppKey
                    //     : newParam.appkey
                    //   : "";
                    // 设置停止原因
                    if (newParam.endCode) {
                      if (this.state.searchEndCode) {
                        newParam.endCode = this.state.searchEndCode;
                      }
                    } else {
                      newParam.endCode = "";
                    }
                    // newParam.endCode = newParam.endCode
                    //   ? this.state.searchEndCode
                    //     ? this.state.searchEndCode
                    //     : newParam.endCode
                    //   : "";
                    // 设置电站名称
                    if (newParam.stubGroupId) {
                      if (this.state.searchStubGroupId) {
                        newParam.stubGroupId = this.state.searchStubGroupId;
                      }
                    } else {
                      newParam.stubGroupId = "";
                    }
                    // newParam.stubGroupId = newParam.stubGroupId
                    //   ? this.state.searchStubGroupId
                    //     ? this.state.searchStubGroupId
                    //     : newParam.stubGroupId
                    //   : "";
                    // 城市id格式化
                    // newParam.cityId =
                    //   newParam.cityId === undefined
                    //     ? ""
                    //     : newParam.cityId
                    //       .toString()
                    //       .slice(
                    //         newParam.cityId.toString().lastIndexOf(",") + 1,
                    //         newParam.cityId.toString().length,
                    //       );

                    if (newParam.cityGroup == null || newParam.cityGroup.length == 0) {
                      newParam.cityId = "";
                    } else {
                      newParam.cityId = newParam.cityGroup.join(",");
                    }

                    let paramString = "";
                    newParam.token = window.sessionStorage.getItem("token");
                    newParam.companyId = window.sessionStorage.getItem("companyId");
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrder(paramString);
                  },
                }
              : "",
            useAuth("050103")
              ? {
                  btnType: "button",
                  text: "枪温监控",
                  handler: (e, param) => {
                    this.modalVisibleAction("seeTempMonitoringState", true);
                    this.setState({
                      seeTempMonitoringState: true,
                    });
                  },
                }
              : "",
            useAuth("050104")
              ? {
                  btnType: "button",
                  text: "异步导出",
                  handler: (e, param) => {
                    const newParam = param;
                    const date = newParam.date.split(",");

                    newParam.startTime = date[0];
                    newParam.endTime = date[1];

                    delete newParam.date;

                    // 设置充电app
                    if (newParam.appkey) {
                      if (this.state.searchAppKey) {
                        newParam.appkey = this.state.searchAppKey;
                      }
                    } else {
                      newParam.appkey = "";
                    }

                    // 设置停止原因
                    if (newParam.endCode) {
                      if (this.state.searchEndCode) {
                        newParam.endCode = this.state.searchEndCode;
                      }
                    } else {
                      newParam.endCode = "";
                    }

                    // 设置电站名称
                    if (newParam.stubGroupId) {
                      if (this.state.searchStubGroupId) {
                        newParam.stubGroupId = this.state.searchStubGroupId;
                      }
                    } else {
                      newParam.stubGroupId = "";
                    }

                    // 城市id格式化
                    if (param.cityGroup == null || param.cityGroup.length == 0) {
                      newParam.cityId = "";
                    } else {
                      newParam.cityId = param.cityGroup.join(",");
                    }
                    delete newParam.cityGroup;

                    fetchHandlerFunc(exportChargingData, { ...newParam }).then((res) => {
                      if (res.code === "success" || res.code === "ok") {
                        message.success("正在导出，稍后请到“系统管理→下载中心”查看");
                      }
                    });
                  },
                }
              : "",
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: this.tableKeyRamdom,
    };

    return formConfig;
  }

  initTable() {
    /**
     * 初始化表格
     */
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: this.internationalization.wz2, // '业务订单号',
            key: "outOrderId",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.title2, // '平台订单号',
            key: "key",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.title5, // '充电状态',
            key: "status",
            align: "left",
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return this.internationalization.title6; // '启动中';
                case 1:
                  return this.internationalization.title7; // '充电中';
                case 9:
                  return this.internationalization.title8; // '充电完成';
                default:
                  return "--";
              }
            },
          },
          {
            name: this.internationalization.wz10, // '充电应用',
            key: "appkeyName",
            align: "left",
            colType: "tipCol",
            render: (text) => (window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: "启动方式", // '运营类型'
            key: "startType",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return "未知";
                case 1:
                  return "APP或微信启动";
                case 2:
                  return "计费卡启动";
                case 3:
                  return "不计费卡启动";
                case 4:
                  return "按钮或屏幕启动";
                case 5:
                  return "擦枪启动";
                case 6:
                  return "命令启动";
                case 7:
                  return "桩定时启动";
                case 8:
                  return "银联卡启动";
                case 9:
                  return "互联互通启动";
                case 10:
                  return "辅枪启动";
                case 11:
                  return "在线VIN";
                case 12:
                  return "离线VIN";
                case 13:
                  return "受电弓";
                case 14:
                  return "在线蓝牙MAC启动";
                case 15:
                  return "OCPP小票机";
                case 16:
                  return "预约即插即充";
                case 17:
                  return "vin即插即充";
                case 18:
                  return "在线蓝牙启动";
                case 19:
                  return "蓝牙即插即充";
                case 20:
                  return "支付宝车生活启动";
                default:
                  return "未知";
              }
            },
          },
          {
            name: this.internationalization.wz8, // '用户编号',
            key: "userId",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.wz6, // '设备编号',
            key: "stubId",
            align: "left",
            colType: "textCol",
          },
          {
            name: "电站名称",
            key: "stubGroupName",
            align: "left",
            colType: "tipCol",
          },
          {
            name: "省", // '地区',
            // key: "cityName",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              var arr = [];
              if (record.cityName) {
                arr = record.cityName.split("-");
              } else {
                var arr = ["--", "--", "--"];
              }

              return (
                <div>
                  <span>{arr[0]}</span>
                </div>
              );
            },
          },
          {
            name: "市", // '地区',
            key: "cityName",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              var arr = [];
              if (record.cityName) {
                arr = record.cityName.split("-");
              } else {
                var arr = ["--", "--", "--"];
              }

              return (
                <div>
                  <span>{arr[1]}</span>
                </div>
              );
            },
          },
          {
            name: "区", // '地区',
            key: "cityName",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              var arr = [];
              if (record.cityName) {
                arr = record.cityName.split("-");
              } else {
                var arr = ["--", "--", "--"];
              }

              return (
                <div>
                  <span>{arr[2]}</span>
                </div>
              );
            },
          },
          {
            name: "充电类型",
            key: "chargeType",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return "交流"; // '非直营';
                case 1:
                  return "直流"; // '直营';
                default:
                  return "未知"; // '未知'
              }
            },
          },
          {
            name: "运营类型",
            key: "type",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return "非直营";
                case 1:
                  return "直营";
                default:
                  return "未知";
              }
            },
          },
          {
            name: "电站类型",
            key: "powerStationType",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value, record) => {
              if (record.type == null) {
                return "";
              } else if (record.type == 1) {
                if (record.powerStationType == null || record.powerStationType == 6) {
                  return "自建站";
                } else if (record.powerStationType == 8) {
                  return "共建站";
                } else {
                  return "";
                }
              } else if (record.type == 0) {
                if (record.powerStationType == null) {
                  return "";
                } else if (record.powerStationType == 0) {
                  return "平台托管联营站";
                } else if (record.powerStationType == 1) {
                  return "品牌联营站";
                } else if (record.powerStationType == 2) {
                  return "互联互通联营站";
                } else if (record.powerStationType == 3) {
                  return "专用开放站";
                } else if (record.powerStationType == 4) {
                  return "专用内部站";
                } else if (record.powerStationType == 5) {
                  return "品牌站";
                }
                // else if (record.powerStationType == 7) {
                //   return '互联互通站';
                // }
              }
            },
          },
          {
            name: "订单金额(元)", // '订单金额(元)',
            key: "feeTotal",
            align: "center",
            colType: "numCol",
            render: (text) => (window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: "服务费用(元)", // '服务费用(元)',
            key: "feeService",
            align: "center",
            colType: "numCol",
            render: (text) => (window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: "电量费用(元)", // '电量费用(元)',
            key: "feeElectric",
            align: "center",
            colType: "numCol",
            render: (text) => (window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: this.internationalization.title3, // '充电时间',
            message: (
              <div className="mcjs">
                <p>充电时间为平台记录时间，充电时间大于实际充电时间。</p>
              </div>
            ),
            key: "timeStart",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              return (
                <div>
                  <span>
                    {record.timeStart}~{record.timeEnd}
                  </span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.wz16, // '实际充电时间'
            message: (
              <div className="mcjs">
                <p>实际充电时间为桩端上报时间</p>
              </div>
            ),
            key: "realStartTime",
            align: "left",
            colType: "textCol",
            render: (text, record) => {
              return (
                <div>
                  <span>
                    {record.realStartTime}~{record.realEndTime}
                  </span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.wz17, // '充电时长' ,
            key: "timeChargeFormat",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.title9, // '停止原因',
            key: "status",
            align: "left",
            colType: "tipCol",
            render: (value, row) => {
              if (row.endInfo) {
                return row.endInfo;
              } else {
                return "--";
              }
            },
          },
          {
            name: this.internationalization.title4, // '电量(度)',
            key: "power",
            align: "center",
            colType: "numCol",
          },
          {
            name: "开始SOC(%)",
            key: "socStart",
            align: "left",
            colType: "textCol",
            render: (text) => (text || text === 0 ? text : "--"),
          },
          {
            name: "结束SOC(%)",
            key: "socEnd",
            align: "left",
            colType: "textCol",
          },
          {
            name: "车牌号",
            key: "carLicenseNo",
            align: "left",
            colType: "textCol",
            render: (text) => (window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: "车辆VIN",
            key: "vin",
            align: "left",
            colType: "textCol",
            render: (text) => (window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: "车型",
            key: "carType",
            align: "left",
            colType: "textCol",
            render: (text) => (text || text === 0 || window.sessionStorage.getItem("companyId") === "1" ? text : "--"), // 1是开迈斯用户，非1不是
          },
          {
            name: "设备型号",
            key: "equipmentModel",
            align: "left",
            colType: "textCol",
          },
          {
            name: "固件信息",
            key: "firmwareInfo",
            align: "left",
            colType: "textCol",
          },
          {
            name: "最大输出电压",
            key: "maxOutputVoltage",
            align: "left",
            colType: "textCol",
          },
          {
            name: "最大输出电流",
            key: "maxOutputCurrent",
            align: "left",
            colType: "textCol",
          },
          {
            name: "最大输出功率",
            key: "maxOutputPower",
            align: "left",
            colType: "textCol",
          },
          {
            name: "最大枪温",
            key: "maxTemperature",
            align: "left",
            colType: "textCol",
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            // width: 150,
            colType: "action",
            actionMap: [
              useAuth("050105")
                ? {
                    type: "href",
                    actionName: this.internationalization.btn3, // '订单详情',
                    handler: (res) => {
                      this.orderDetailInfo = res;
                      this.modalVisibleAction("seeDetailVisible", true);
                      this.setState({
                        seeDetailVisible: true,
                      });
                    },
                  }
                : "",
              useAuth("050106")
                ? {
                    type: "href",
                    actionName: this.internationalization.wz18, // '充电数据',
                    handler: (res) => {
                      this.openTab(
                        {
                          keyId: "chargeCourse",
                          orderId: res.key,
                        },
                        {
                          key: "chargeCourse",
                          titleText: this.internationalization.wz18, 
                        },
                      );
                      if (this.props.cancelModal) {
                        this.props.cancelModal();
                      }
                    },
                  }
                : "",
              useAuth("050107")
                ? {
                    type: "href",
                    actionName: this.internationalization.wz19, // '模块数据',
                    handler: (res) => {
                      this.openTab(
                        {
                          keyId: "powerCourse",
                          orderId: res.key,
                        },
                        {
                          key: "powerCourse",
                          titleText: this.internationalization.wz19, // '模块数据'
                        },
                      );
                      if (this.props.cancelModal) {
                        this.props.cancelModal();
                      }
                    },
                  }
                : "",
              useAuth("050108")
                ? {
                    type: "href",
                    actionName: this.internationalization.wz20, // '平台日志',
                    handler: (res) => {
                      this.openTab(
                        {
                          keyId: "0502",
                          orderId: res.key,
                          stubId: res.stubId,
                          startTime: res.timeStart,
                          endTime: res.timeEnd,
                        },
                        {
                          key: "0502",
                          titleText: "桩连平台日志",
                        },
                      );
                      if (this.props.cancelModal) {
                        this.props.cancelModal();
                      }
                    },
                  }
                : "",
              useAuth("050109")
                ? {
                    type: "confirm",
                    actionName: "强制停止",
                    popText: () => {
                      return `确定要强制停止订单吗？`;
                    },
                    render: (record) => {
                      return record.status !== 1 ? null : (
                        <span className="tableBtn">强制停止</span>
                      );
                    },
                    handler: (record) => {
                      fetchHandlerFunc(orderForceStop, {
                        appkey: record.appkey,
                        orderId: record.key,
                      }).then((res) => {
                        if (res.code === "success" || res.code === "ok") {
                          message.success(`订单${record.key}已强制停止`);
                          RefreshGrid(this.context.store, this.tableKeyRamdom);
                        }
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
          console.debug("change");
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getStubOrderInfoList,
        tableKey: this.tableKeyRamdom,
      },
    });
  }

  // 新开页方法
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 关闭modal框方法
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    const newParam = param;
    const date = newParam.date.split(",");

    newParam.startTime = date[0];
    newParam.endTime = date[1];

    delete newParam.date;

    // 设置充电app
    if (newParam.appkey) {
      if (this.state.searchAppKey) {
        newParam.appkey = this.state.searchAppKey;
      }
    } else {
      newParam.appkey = "";
    }
    // newParam.appkey = newParam.appkey
    //   ? this.state.searchAppKey
    //     ? this.state.searchAppKey
    //     : newParam.appkey
    //   : "";

    // 设置停止原因
    if (newParam.endCode) {
      if (this.state.searchEndCode) {
        newParam.endCode = this.state.searchEndCode;
      }
    } else {
      newParam.endCode = "";
    }
    // newParam.endCode = newParam.endCode
    //   ? this.state.searchEndCode
    //     ? this.state.searchEndCode
    //     : newParam.endCode
    //   : "";

    // 设置电站名称
    // console.info(newParam.stubGroupId);
    if (newParam.stubGroupId) {
      if (this.state.searchStubGroupId) {
        newParam.stubGroupId = this.state.searchStubGroupId;
      }
    } else {
      newParam.stubGroupId = "";
    }
    // newParam.stubGroupId = newParam.stubGroupId
    //   ? this.state.searchStubGroupId
    //     ? this.state.searchStubGroupId
    //     : newParam.stubGroupId
    //   : "";

    // 城市id格式化
    // newParam.cityId =
    //   newParam.cityId === undefined
    //     ? ""
    //     : newParam.cityId
    //       .toString()
    //       .slice(
    //         newParam.cityId.toString().lastIndexOf(",") + 1,
    //         newParam.cityId.toString().length,
    //       );

    if (param.cityGroup == null || param.cityGroup.length == 0) {
      newParam.cityId = "";
    } else {
      newParam.cityId = param.cityGroup.join(",");
    }
    delete newParam.cityGroup;

    // 如果正常页面中的表单提交，请执行下面
    return RefreshGrid(this.context.store, this.tableKeyRamdom, newParam);
  };

  // 导出订单
  exportOrder = (paramString) => {
    const excelUrl = `${prefixFile}/exportOrderList.do`;
    // console.log(excelUrl);
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  // 选择电站操作
  setStubGroupInfo = (record) => {
    // 关闭弹窗
    this.modalVisibleAction("seeChooseState", false);
    this.setState(
      {
        choosedStubGroupName: record.name,
        choosedStubGroupKey: record.key,
      },
      () => {
        this.setState({
          formConfig: this.initFormConfig(),
        });
      },
    );
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel stub-orderinfo-table">
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>
        <Modal
          title={this.internationalization.btn6}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <OrderDetailInfo orderDetailInfo={this.orderDetailInfo} />
        </Modal>
        {/* 选择电站 */}
        <Modal
          title="选择电站"
          width="800px"
          footer={null}
          visible={this.state.seeChooseState}
          onCancel={() => {
            this.modalVisibleAction("seeChooseState", false);
          }}>
          <StubGroupChoose setStubGroupInfo={this.setStubGroupInfo} />
        </Modal>
        {/* 枪温监控 */}
        <Modal
          title="枪温监控"
          width="1000px"
          footer={null}
          destroyOnClose
          visible={this.state.seeTempMonitoringState}
          onCancel={() => {
            this.modalVisibleAction("seeTempMonitoringState", false);
          }}>
          <StubTempMonitoring setStubGroupInfo={this.setStubGroupInfo} />
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(StubOrderInfo);
StubOrderInfo.propTypes = {
  // layout: PropTypes.string,
  // modalSubmit: PropTypes.func,
  // tableKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubOrderInfo.js